<template>
  <div class="default-loading">
    <div class="loading-cont">
      <div class="loading-dot clearfix">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <div class="loading-msg"
           v-if="$slots.default || message">
        <slot>{{message}}</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultLoading',
  props: {
    message: {
      type: String,
      default: '加载中...'
    }
  }
}
</script>

<style lang="scss">
  .default-loading {
    position: relative;
    height: 100%;
    min-width: 200px;
    min-height: 75px;
    & > .loading-cont {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      & > .loading-dot {
        white-space: nowrap;
        & > .dot {
          display: inline-block;
          width: 9px;
          height: 9px;
          border: 1px solid #999;
          &:nth-child(1) {
            animation: popover-loading 1s linear 0s infinite;
          }
          &:nth-child(2) {
            animation: popover-loading 1s linear .2s infinite;
          }
          &:nth-child(3) {
            animation: popover-loading 1s linear .4s infinite;
          }
          &:nth-child(4) {
            animation: popover-loading 1s linear .6s infinite;
          }
          &:nth-child(5) {
            animation: popover-loading 1s linear .8s infinite;
          }
          & + .dot {
            margin-left: 6px;
          }
        }
      }
      & > .loading-msg {
        margin-top: 5px;
        text-align: center;
        font-size: 12px;
        color: #909399;
      }
    }
    @keyframes popover-loading {
      0%{
        background-color: #999;
      }
      20%{
        background-color: #999999bf;
      }
      40%{
        background-color: #99999980;
      }
      60%{
        background-color: #99999940;
      }
      80%{
        background-color: transparent;
      }
      100%{
        background-color: transparent;
      }
    }
  }
</style>
